<img class="lightbox-image" [src]="media.links.fileUrl" />
